/**
 * 图片url过滤
 * @param {String} url
 */
function filterImgUrl (url) {
  if (url.match(/^http/) && url.match(/^http/)['index'] === 0) {
    return url
  }
  if (url.match(/^https/) && url.match(/^https/)['index'] === 0) {
    return url
  }
  if (url.match(/^\/\//) && url.match(/^\/\//)['index'] === 0) {
    return url
  }
  return `//${url}`
}

function ensureHttpUrl (url, protocol = 'https') {
  if (url.startsWith('http:') || url.startsWith('https:')) {
    return url
  }
  if (url.startsWith('//')) {
    return protocol + ':' + url
  }

  return protocol + '://' + url
}

function ensureDoubleSlash (url) {
  let r = /^https?/
  if (r.test(url) || r.test(url)) {
    return url.replace(r, '')
  }

  if (url.startsWith('//')) {
    return url
  }

  return '//' + url
}

export {filterImgUrl, ensureHttpUrl, ensureDoubleSlash}



// WEBPACK FOOTER //
// ./src/common/util/filterImgUrl.js